// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 339 ? "GalleryImageElement" : chunkId) + "." + {"339":"f8e99c404bed3e98","751":"d9cb1f2201bfeae4","766":"24c4955566af1b88"}[chunkId] + ".js";
};